import './searchField.css';
import { DebounceInput } from 'react-debounce-input';

export const SearchField = ({
    value,
    onChange,
    children,
    placeholder,
    minLengthForSearch = 1,
    debounceTimeout = 200,
    className,
}) => {
    const setSearchValue = e => onChange && onChange(e.target.value);

    return (
        <div className={`flex flex-center search-field ${className}`}>
            <div className="flex-grow flex flex-center mr10">
                <i className={`fa fa-search ${value ? '' : 'disabled'}`} />
                <DebounceInput
                    minLength={minLengthForSearch}
                    debounceTimeout={debounceTimeout}
                    className="form-control flex-grow"
                    type="text"
                    id="search-field"
                    data-testid="search-box"
                    value={value}
                    onChange={setSearchValue}
                    placeholder={placeholder}
                    autoComplete="chrome-off"
                />
            </div>
            {children}
        </div>
    );
};

export default SearchField;
